import { Menu as MUIMenu, MenuProps, styled } from "@mui/material";

const StyledMenu = styled(MUIMenu)(() => ({
  ".MuiPaper-rounded": {
    borderRadius: "0.5rem",
    minWidth: "10rem",
  },
}));

const Menu = ({ children, anchorEl, onClose, open, ...rest }: MenuProps) => {
  return (
    <>
      <StyledMenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        {...rest}
      >
        {children}
      </StyledMenu>
    </>
  );
};

export { Menu };
export default Menu;
